import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
import CustomDataTable from '../components/CustomDataTable'
const AttendanceReport = () => {
    const empcode = localStorage.getItem('empcode');
    const [data, setData] = useState([]);
    const [plants, setPlants] = useState([]); // Corrected from singular
    const [departments, setDepartments] = useState([]);
    const [company, setCompany] = useState([]);
    const [vender, setVender] = useState([]);
    const { setLoading } = useLoading();
    // 🔹 Toggles for filters and table
    const [showFilters, setShowFilters] = useState(true);
    const [showTable, setShowTable] = useState(true);
    const [filters, setFilters] = useState({
        CompanyName: '',
        PlantName: '',
        VenderName: '',
        DepartmentName: '',
        EmployeeCode: '',
        EmployeeName: '',
        DoJStart: '',
        DoJEnd: '',
        EmployeeStatus: '1'
    });

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [
                // deptRes,
                plantRes, companyRes, venderRes] = await Promise.all([
                    //EmployeeProcessService.getDepartment(empcode),
                    EmployeeProcessService.getPlant(empcode),
                    EmployeeProcessService.getCompany('User'),
                    EmployeeProcessService.getVender('User')
                ]);
            // if (deptRes?.data?.statusCode === 200) setDepartments(deptRes.data.result);
            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result); // fixed
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    // 🔹 Load departments when Plant changes
    const handlePlantChange = async (e) => {
        const plantId = e.target.value;
        setFilters(prev => ({ ...prev, PlantName: plantId, DepartmentName: "" }));
        setDepartments([]);

        if (!plantId) return;

        try {
            const res = await EmployeeProcessService.getDepartment(empcode, plantId);
            if (res?.data?.statusCode === 200) {
                setDepartments(res.data.result);
            } else {
                setDepartments([]);
            }
        } catch (error) {
            console.error("Error loading departments:", error);
        }
    };
    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await EmployeeProcessService.getEmployeeSalaryReport(filters);
            if (response.data.statusCode === 200 && response.data.result.length > 0) {
                setData(response.data.result);
                setLoading(false);
                // toast.success("Data loaded");
            } else {
                setLoading(false);
                alert("No records found");
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            // console.error('Error fetching data:', error);
            setData([]);
            alert("No records found");
        }
    };

    const applyFilters = () => {
        // if (filters.CompanyName =="" ) {
        //     alert("Please select Company.");
        //     return;
        // }
        // if (filters.PlantName =="") {
        //     alert("Please select Plant.");
        //     return;
        // }
        if (filters.DoJStart == '' && filters.DoJEnd == '') {
            alert("Select Start date and end date.");
            return;
        }

        if (filters.DoJStart && filters.DoJEnd && filters.DoJStart > filters.DoJEnd) {
            alert("Start date cannot be after end date.");
            return;
        }
        debugger;
        fetchData();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };
    const downloadExcel = () => {
        const worksheetData = data.map(emp => ({
            Code: emp.code,
            Name: emp.name,
            Plant: emp.plantName,
            Vendor: emp.vendorName,
            Department: emp.department,
            "Tot Days": emp.totDays,
            "Present Days": emp.presentDays,
            Absent: emp.absent,
            HalfDay: emp.halfDay,
            "W/o": emp.wo,
            Holiday: emp.holiday,
            Sandwich:emp.sandwich,
            TotalPaidDays: emp.totalPaidDays,
            TotalHour: emp.totalHours,
            Incentive: emp.incentive,
            Performance: emp.performance,
            Expected: emp.expected,
            Actual: emp.actual,
            Deducted: emp.deducted
        }));

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

        XLSX.writeFile(workbook, "AttendanceReport.xlsx"); // This downloads the file
    };

    return (
        <div className="container mt-1">
            {/* 🔹 Section 1: Heading */}
            <div className="mb-1 p-2 bg-light rounded">
                <h7 className="m-0 text-primary">Attendance Report</h7>
            </div>
            {/* 🔹 Section 2: Filters with toggle */}
            <div
                className="d-flex justify-content-between align-items-center mb-1 p-2 bg-secondary bg-opacity-10 rounded"
                style={{ cursor: "pointer" }}
                onClick={() => setShowFilters(!showFilters)}
            >
                <h7 className="m-0">Filters</h7>
                <span style={{ fontSize: "11px" }}>{showFilters ? "▲" : "▼"}</span>
            </div>
            {showFilters && (
                <>
                    <div className="row filter-section">
                        {/* Company */}
                        <div className="col-md-3">
                            <label className="filter-label text-primary">Select Company</label>
                            <select name="CompanyName" value={filters.CompanyName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Company</option>
                                {company.map(comp => (
                                    <option key={comp.id} value={comp.id}>{comp.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="filter-label text-primary">
                                Select Plant</label>
                            <select name="PlantName" value={filters.PlantName} onChange={handlePlantChange}
                                className="form-select filter-input">
                                <option value="">Select Plant</option>
                                {plants.map(plan => (
                                    <option key={plan.id} value={plan.id}>{plan.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="filter-label text-primary">
                                Select Vendor</label>
                            <select name="VenderName" value={filters.VenderName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Vendor</option>
                                {vender.map(ven => (
                                    <option key={ven.id} value={ven.id}>{ven.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="filter-label text-primary">
                                Select Department</label>
                            <select name="DepartmentName" value={filters.DepartmentName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Department</option>
                                {departments.map(dept => (
                                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="row mb-3 filter-section">
                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    From</label>
                                <input
                                    type="date"
                                    name="DoJStart"
                                    value={filters.DoJStart}
                                    onChange={handleChange}
                                    className="form-control filter-input" />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    To</label>
                                <input
                                    type="date"
                                    name="DoJEnd"
                                    value={filters.DoJEnd}
                                    onChange={handleChange}
                                    className="form-control filter-input" />
                            </div>
                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    Employee Code</label>
                                <input
                                    name="EmployeeCode"
                                    value={filters.EmployeeCode}
                                    placeholder="Employee Code"
                                    onChange={handleChange}
                                    className="form-control  filter-input"
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    Employee Name</label>
                                <input
                                    name="EmployeeName"
                                    value={filters.EmployeeName}
                                    placeholder="Employee Name"
                                    onChange={handleChange}
                                    className="form-control filter-input"
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="text-primary">Employee Status</label>
                                <select className="form-select" name="EmployeeStatus" value={filters.EmployeeStatus} onChange={handleChange}>
                                    {/* <option value="">Employee Status</option> */}
                                    <option value="1">Active</option>
                                    <option value="0">In Active</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-2 mb-3 flex-wrap">
                        <button className="btn btn-primary filter-btn" onClick={applyFilters}>Search</button>
                        {data.length > 0 && (
                            <button className="btn btn-success filter-btn" onClick={downloadExcel}>Download Excel</button>
                        )}
                    </div>
                </>
            )}

            {/* 🔹 Section 3: Data Table with toggle */}
            <div
                className="d-flex justify-content-between align-items-center mb-1 p-1 bg-secondary bg-opacity-10 rounded"
                style={{ cursor: "pointer" }}
                onClick={() => setShowTable(!showTable)}
            >
                <h7 className="m-0">Data</h7>
                <span style={{ fontSize: "11px" }}>{showFilters ? "▲" : "▼"}</span>
            </div>

            {showTable && (
                <div className="table-responsive">
                    <CustomDataTable data={data} title="Employee List" />
                </div>
            )}
        </div>
    );
};

export default AttendanceReport;
